
import React, { Component, Fragment } from 'react';
import Panel from '@/components/Panel';
import { createPortal } from 'react-dom';
import { Spin } from 'antd';
import { getPanelMaxHeight } from '../../../../services/helper/panelSizeHelper';
import CustomInterfacesDefinition from './index';
import { getCustomInterfacesLibrary } from '../../../../services/Sierra/library';
import "../sierraPanel.css"
import "./index.css"

class CustomInterfacesDefinitionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.libraryName,
      nameError: "", // name format error info
      loading: true,
      maxHeight: 800,
      definitionConfig: {}
    }
    this.dialogRoot = document.getElementById('root');
    this.inputRef = {};
  }

  async componentDidMount() {
    this.resize();
    this.getConfig()
  }

  getConfig = async () => {
    const { libraryId, libraryName } = this.props;
    try {
      let definitionConfig = {}
      if (libraryId) {
        definitionConfig = await getCustomInterfacesLibrary(libraryId);
      }
      this.setState({ name: libraryName, definitionConfig, loading: false });
    } catch (error) {
      this.setState({ name: libraryName, definitionConfig: {}, loading: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxHeight: getPanelMaxHeight(offset, 800) - 80,
    })
  }

  async componentDidUpdate(prevProps) {
    const { libraryId } = this.props;
    if (prevProps.libraryId !== libraryId) {
      this.setState({ loading: true }, () => {
        this.getConfig()
      })
    }
  }

  closeModal = () => {
    if (this.childRef && this.childRef.saveConfig) {
      this.childRef.saveConfig()
    }
    this.props.closeLibraryPanel();
  }

  onRef = (ref) => {
    this.childRef = ref;
  }

  render() {
    const { title, libraryId } = this.props;
    const { loading, maxHeight, definitionConfig, name } = this.state;
    const content = (
      <Fragment>
        <Panel
          className='sierra-panel'
          position='panel-center-left'
          title={`${title} - ${name}`}
          zIndex={2000}
          onCancel={this.closeModal}
          width={600}
          draggable
          minHeight={200}
          maxHeight={maxHeight}
        >
          <Spin tip="Loading..." spinning={loading}>
            <div className='aurora-custom-interfaces-definition-content'>
              <CustomInterfacesDefinition
                onRef={this.onRef}
                loading={loading}
                allowChangeLib={false}
                advancedConfig={{
                  id: libraryId,
                  name,
                  config: definitionConfig ? definitionConfig.definition || {} : {}
                }}
              />
            </div>
          </Spin>
        </Panel>
      </Fragment>
    )
    return createPortal(content, this.dialogRoot)
  }
}

export default CustomInterfacesDefinitionPanel;